module.exports = __webpack_public_path__ + "static/media/question_icon.7fc27098.svg";